import React, { useState } from 'react';
import logo from '../assets/logo.png';

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-wrapper">
          <div className="logo">
            <img src={logo} alt="유니원솔루션" className="logo-img" />
            <span className="logo-text">유니원솔루션</span>
          </div>
          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`} id="navMenu">
            <li><a href="#about" onClick={handleLinkClick}>회사소개</a></li>
            <li><a href="#services" onClick={handleLinkClick}>사업분야</a></li>
            <li><a href="#competencies" onClick={handleLinkClick}>핵심역량</a></li>
            <li><a href="#projects" onClick={handleLinkClick}>수행프로젝트</a></li>
            <li><a href="#contact" onClick={handleLinkClick}>문의하기</a></li>
          </ul>
          <button 
            className={`hamburger ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
